import Tags from '../components/tags/tag'

export default {
  Tags
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/resources/components.js